const IMAGE_SM = '200x0';
const IMAGE_PREVIEW_SM = '300x300';

export {IMAGE_SM,IMAGE_PREVIEW_SM}